import { ListItem, ListItemText } from "@mui/material";
import { Divider, Typography, Stack } from "@financeable-com-au/financeable-ui";
import { getIsAssetLoan, getIsCommercialOrBusinessApplication, getIsConsumerOrPersonalApplication } from "@/constants";
import { ApplicationType } from "@/store/slices/types/applicationFormSlice";

export const CustomListItemText = ({
  primaryTitle,
  secondaryList,
}: {
  primaryTitle: string;
  secondaryList: string[];
}) => (
  <ListItem disablePadding>
    <ListItemText
      primary={
        <Typography level="body-sm" fontWeight="bold">
          • {primaryTitle}
        </Typography>
      }
      secondary={
        <Stack pl={1}>
          {secondaryList.map((item: string, index: number) => (
            <Typography key={index} level="body-sm">
              - {item}
            </Typography>
          ))}
        </Stack>
      }
    />
  </ListItem>
);

export const ApplicationTypeUpdateAdditionalDetails = ({
  newApplicationType,
  isProductQuotesExist,
  isLenderFiltersExist,
}: {
  newApplicationType: ApplicationType;
  isProductQuotesExist: boolean;
  isLenderFiltersExist: boolean;
}) => {
  const isAssetLoan = getIsAssetLoan(newApplicationType);
  const isConsumerOrPersonalApplication = getIsConsumerOrPersonalApplication(newApplicationType);
  const isCommercialOrBusinessApplication = getIsCommercialOrBusinessApplication(newApplicationType);

  return (
    <Stack flexDirection="column" rowGap={1} padding={1} alignItems={"flex-start"}>
      <Typography level="body-sm" fontWeight="lg">
        The following data fields will be affected by changing the application type to {newApplicationType}
      </Typography>

      <Divider />

      <Stack flexDirection="column">
        {/* Customer */}
        {isCommercialOrBusinessApplication && (
          <CustomListItemText primaryTitle="Customer" secondaryList={["Income", "Expenses", "Employer"]} />
        )}

        {isConsumerOrPersonalApplication && (
          <CustomListItemText primaryTitle="Entity" secondaryList={["All entities will be removed"]} />
        )}

        {/* Asset */}
        {isAssetLoan && <CustomListItemText primaryTitle="Asset" secondaryList={["Asset type"]} />}

        {/* Quotes */}
        {isProductQuotesExist && (
          <CustomListItemText primaryTitle="Quotes" secondaryList={["All quotes will be removed"]} />
        )}

        {/* Lender */}
        {isLenderFiltersExist && (
          <CustomListItemText primaryTitle="Lender Filters" secondaryList={["Remove lender filter By"]} />
        )}
      </Stack>

      <Typography level="body-sm" fontWeight="md" marginTop={1}>
        <strong>Note:</strong> Privacy documents may need to be re-uploaded after the application type is updated.
      </Typography>
    </Stack>
  );
};
